import { postApiGalaxyServer, getApiGalaxyServer, putApiGalaxyServer } from 'services/api';
import {
  resetMemberPasswordParams,
  provisionQbdParams,
  SetSingleUserTemporaryPasswordParams,
  bulkActivateAccountsParams,
  fetchProvisionErrorsParams,
  provisionCustomerParams,
} from 'ProfileModule/types';

export const getTeamMember = (teamId: number, config: object = {}, token = '') =>
  getApiGalaxyServer(`/rails_api/teams/${teamId}/team_memberships`, config as any, token);

// Server-side paginated / filterable / sortable team-members listing (GLX-1740).
// Pagination, sorting, filtering and system-account hiding are all applied by
// Rails; query params (limit, offset, account_ids[], name, email, sort,
// sort_direction, include_discarded) are passed through `config.params`.
export const searchTeamMembers = (teamId: number, config: object = {}, token = '') =>
  getApiGalaxyServer(`/rails_api/teams/${teamId}/team_memberships/search`, config as any, token);

export const updateTeamMember = (
  teamMembershipId: number,
  data: Record<any, any>,
  config: object = {},
  token: string,
) =>
  putApiGalaxyServer(`/rails_api/team_memberships/${teamMembershipId}`, data, config as any, token);

export const resetMemberPassword = (
  body: resetMemberPasswordParams,
  config: object = {},
  token: string,
) => postApiGalaxyServer('/rails_api/reset_passwords', body, config as any, token);

const forwardProvisionCompany = (
  { targetService, teamId }: provisionQbdParams | provisionCustomerParams,
  config: Record<string, any>,
  token: string,
) =>
  getApiGalaxyServer(
    `/integrations_api/forward/${targetService}/provision-company/${teamId}`,
    config,
    token,
  );

// remove after QBD is fully deprecated
export const provisionQbd = forwardProvisionCompany;

export const provisionCustomer = forwardProvisionCompany;

export const fetchProvisionErrors = (
  { teamId }: fetchProvisionErrorsParams,
  config: Record<string, any>,
  token: string,
) => getApiGalaxyServer(`/integrations_api/telemetry/provisionLogs/${teamId}`, config, token);

export const setSingleUserTemporaryPassword = (
  body: SetSingleUserTemporaryPasswordParams,
  config: Record<string, any>,
  token: string,
) => postApiGalaxyServer(`/rails_api/auth_server/account_set_password`, body, config, token);

export const bulkActivateAccounts = (
  body: bulkActivateAccountsParams,
  config: Record<string, any>,
  token: string,
) => postApiGalaxyServer(`/rails_api/account/bulk-force-activate`, body, config, token);
